var _rect, _path, _path2, _path3, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0253906,
    y: 0.862183,
    width: 95.2396,
    height: 95.2396,
    rx: 20.3547,
    fill: "#5E1B0C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8196 25.7841H79.061C82.1456 25.7841 83.6969 29.5076 81.5247 31.6977L49.3739 64.1134C48.0079 65.4907 45.778 65.4807 44.4245 64.0911L30.1582 49.4451C28.8493 48.1014 28.8452 45.9609 30.1488 44.6122L47.3246 26.8425C47.9784 26.166 48.8789 25.7841 49.8196 25.7841Z",
    fill: "#FE6533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0182 25.7841H16.1019C13.0832 25.7841 11.5041 29.372 13.5431 31.5979L47.0982 68.2298C48.433 69.687 50.7134 69.7369 52.1107 68.3396L66.2888 54.1615C67.6079 52.8425 67.6481 50.7166 66.3798 49.3487L45.5629 26.8949C44.9062 26.1866 43.9841 25.7841 43.0182 25.7841Z",
    fill: "#F8F7F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3584 34.0815L46.397 27.7362L52.379 34.1349L46.3217 39.9956C44.6782 41.5858 42.0647 41.5689 40.4418 39.9578C38.8202 38.3478 38.7831 35.7368 40.3584 34.0815Z",
    fill: "#FE6533"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8066,
    y: 49.8407,
    width: 8.25598,
    height: 28.9304,
    rx: 4.12799,
    transform: "rotate(-42.8643 24.8066 49.8407)",
    fill: "#FE6533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/Sales.2556a104e615971916e07fe4ab8b26d1.svg";
export { ForwardRef as ReactComponent };